export enum HttpHeaders {
	USER_TOKEN = 'user-token',
}
